import { memo, useState, useEffect } from 'react';
import { Markup } from 'interweave';
import { useLocation } from 'react-router-dom';
import { addPointsInText, boldBetweenAsterisks } from '../../../../helpers/app';
import InformationLoader from '../../Loader/Information/InformationLoader';
import DetailLoader from '../../Loader/Detail/DetailLoader';
import { images } from '../../../../constants/images';
import { PublicationInformationProps } from '../../interfaces';
import styles from '../../publicationDetail.module.scss';
import Button from '../../../Button';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import { usePublicationRecords } from '../../hooks/usePublicationRecords';
import FinancingChip from '../FinancingChip/FinancingChip';
import StarIcon from '@mui/icons-material/Star';
import VerifiedOutlinedIcon from '@mui/icons-material/VerifiedOutlined';

const PublicationInformation = (props: PublicationInformationProps) => {
  const {
    publication,
    loading,
    logoDealerships,
    handleDealerLogoClick,
    brand,
    type,
    vehicleTypeSelected,
    children,
    getMinPrice,
    hasValidSuggestedPricesPublication,
    getPriceCategoryPublication,
    selectedVehicleData,
    isPriceIndicatorVisible,
    loginBancoChile,
    loginBancoChileData,
    loginBancoChileFetching
  } = props;

  const location = useLocation();
  const { images } = require('../../../../constants/images');
  const [bancoChilePopup, setBancoChilePopup] = useState<any>(null);
  const [shouldOpenPopup, setShouldOpenPopup] = useState(false);

  const { recordsToShow } = usePublicationRecords({ publication, type });

  // // Abrir popup cuando se obtiene la URL
  // useEffect(() => {
  //   if (loginBancoChileFetching === 'success' && loginBancoChileData?.data?.authUrl && shouldOpenPopup) {
  //     // Abrir popup con window.open
  //     const popup = window.open(
  //       loginBancoChileData.data.authUrl,
  //       'bchAuth',
  //       'width=500,height=600,left=300,top=100'
  //     );

  //     if (popup) {
  //       // Monitorear el cierre del popup
  //       const checkPopupClosed = setInterval(() => {
  //         try {
  //           if (popup.closed) {
  //             clearInterval(checkPopupClosed);
  //             setShouldOpenPopup(false);
  //           }
  //         } catch (e) {
  //           clearInterval(checkPopupClosed);
  //         }
  //       }, 500);
  //     }

  //     setShouldOpenPopup(false); // Reset el flag
  //   }
  // }, [loginBancoChileFetching, loginBancoChileData, shouldOpenPopup]);

  const handleLoginBancoChile = () => {
    // if (loginBancoChile && typeof loginBancoChile === 'function') {
    //   setShouldOpenPopup(true); // Establecer el flag para abrir el popup
    //   loginBancoChile();
    // }
  };

  if (loading && !publication?.id_publication) {
    return (
      <div className={`${styles.information} ${loading && styles.loader}`}>
        <InformationLoader />
      </div>
    );
  }

  const renderPriceIndicator = () => {
    if (publication?.opportunity === true) {
      return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <StarIcon
            className={styles.priceIcon}
            style={{ width: '16px', height: '16px', marginRight: '4px', color: '#7100FF' }}
          />
          <p style={{ padding: '0', margin: '0', marginTop: '2px', color: '#000000' }}>Oportunidad</p>
        </div>
      );
    }

    if (!hasValidSuggestedPricesPublication || !getPriceCategoryPublication) {
      return null;
    }

    if (getPriceCategoryPublication() === "good" || getPriceCategoryPublication() === "fair") {
      return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <img
            src={
              getPriceCategoryPublication() === "good"
                ? images.checkVerde
                : images.checkAmarillo
            }
            alt="Indicador de precio"
            title="Indicador de precio"
            className={styles.priceIcon}
            style={{ width: '16px', height: '16px', marginRight: '4px' }}
          />
          {getPriceCategoryPublication() === "good"
            ? "Buen precio"
            : "Precio justo"}
        </div>
      );
    }

    return null;
  };

  const renderPrice = () => {
    if (brand) {
      return (
        <>
          <p className={styles.pricesBrand}>Desde ${addPointsInText(getMinPrice)} (*)</p>
          <p className={styles.subTextPricesBrand}>(*) Precios referenciales</p>
        </>
      );
    }
    return null;
  };

  const renderStatusAndActions = () => {
    if (publication?.status_brief?.code === "sold_out") {
      return <h3 className={styles.sold}>Vendido</h3>;
    }
    if (type === 'myPublication' || type === 'publication') {
      return (
        <div style={{ width: 'auto' }}>
          {renderPriceIndicator()}
        </div>
      );
    }

    if (type === 'salePost') {
      return (
        <div style={{ width: 'auto' }}>
          {renderPriceIndicator()}
        </div>
      );
    }

    return null;
  };

  const isDefaultRecord = (item: any): boolean => {
    const defaultTexts = [
      'Sin datos de uso comercial o personal',
      'Sin informacion de propietarios',
      'Sin datos sobre accidentes reportados',
    ];
    if (defaultTexts.includes(item?.value)) return true;
    return false;
  };

  const getChipLabel = (item: any): string => {
    if (isDefaultRecord(item)) {
      const emptyLabels: Record<string, string> = {
        personal_use: 'Uso: N/D',
        sole_owner: 'Dueños: N/D',
        accidents_reported: 'Accidentes: N/D',
      };
      return emptyLabels[item.key] || item.value;
    }

    switch (item.key) {
      case 'personal_use': {
        if (item.value.toLowerCase().includes('personal')) return 'Uso particular';
        if (item.value.toLowerCase().includes('comercial')) return 'Uso comercial';
        return 'Uso particular';
      }
      case 'sole_owner': {
        const num = item.value.match(/\d+/);
        if (num) return `Dueños: ${num[0]}`;
        if (item.value.toLowerCase().includes('único') || item.value.toLowerCase().includes('unico')) return 'Dueño unico';
        if (item.value.toLowerCase().includes('multiple') || item.value.toLowerCase().includes('múltiple')) return 'Varios dueños';
        return 'Dueño unico';
      }
      case 'accidents_reported': {
        if (item.value.toLowerCase().includes('con')) return 'Con accidentes';
        return 'Sin accidentes';
      }
      default:
        return item.value;
    }
  };

  const renderDetails = () => {
    if (loading) {
      return (
        <ul className={styles.detail}>
          <DetailLoader />
        </ul>
      );
    }

    const hasAnyData = recordsToShow.some((item: any) => !isDefaultRecord(item));
    const allEmpty = recordsToShow.every((item: any) => isDefaultRecord(item));

    // No data at all — single "Sin registros" chip
    if (allEmpty) {
      return 
    }

    return (
      <div className={styles.sellerInfoChips}>
        {recordsToShow.map((item: any, index: number) => (
          <div
            key={index}
            className={isDefaultRecord(item) ? styles.chipEmpty : styles.chipFilled}
          >
            <img src={item?.icon} alt={item?.name || item?.key} className={styles.chipIcon} />
            <span>{getChipLabel(item)}</span>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className={`${styles.information} ${(publication?.certified || publication?.financingBonus) && styles.notPaddingBottom}`}>
      {/* Logo del concesionario */}
      {logoDealerships && (
        <div className={brand ? styles.brandLogo : styles.dealerLogo} onClick={handleDealerLogoClick}>
          <img src={logoDealerships} alt={brand ? "Brand logo" : "Dealer logo"} title={brand ? "Brand logo" : "Dealer logo"} />
        </div>
      )}

      {/* Descripción básica */}
      <p className={styles.description}>
        {selectedVehicleData?.year || publication?.vehicle_data?.year} | {addPointsInText(selectedVehicleData?.mileage || publication?.vehicle_data?.mileage)} km
      </p>

      {/* Título */}
      <h2 className={styles.title}>{publication?.title}</h2>

      {/* Versión */}
      {publication?.vehicle_data?.version && !brand && (
        <h3 className={styles.version}>{publication?.vehicle_data?.version.toUpperCase()}</h3>
      )}

      {/* Región (antes del precio) */}
      {!brand && (
        <p className={styles.region}>
          <LocationOnOutlinedIcon className={styles.regionIcon} />
          <span className={styles.regionText}>{publication?.region}</span>
        </p>
      )}

      {/* Precio y estado */}
      {brand ? (
        <>
          <p className={styles.pricesBrand}>Desde ${addPointsInText(getMinPrice)} (*)</p>
          <p className={styles.subTextPricesBrand}>(*) Precios referenciales</p>
        </>
      ) : (
        <>
          <div className={type === 'myPublication' ? styles.priceContainerMyPublication : styles.priceContainer}>
            <div className={styles.priceIvaGroup}>
              <p className={styles.price}>$ {addPointsInText(publication?.price)}</p>
              {publication?.detail_edit?.iva && vehicleTypeSelected && <p className={styles.indicatorIVA}>+ IVA</p>}
            </div>
            {publication?.status_brief?.code !== "sold_out" && (type === 'myPublication' || type === 'publication' || type === 'salePost') && renderPriceIndicator()}
          </div>
        </>
      )}

      {/* Children (botones de acción) — ahora después del precio */}
      {type !== "myPublication" && type !== "salePost" ? children : null}
      {type === "salePost" ? <div className={styles.buttonss}>
        <Button
          className={styles.btn}
          title="Negociar"
          onPress={() => console.log('Negociar')}
          tertiary
          disabled
          size='small'
        />
        <Button
          className={styles.btn}
          title="Comprar"
          onPress={() => console.log('Comprar')}
          primary
          disabled
          size='small'
        />
      </div> : null}

      {/* Detalles del vendedor como chips — ahora después de los botones */}
      {!brand && (
        <div className={isPriceIndicatorVisible ? styles.detailsWithPriceIndicator : styles.detailsWithoutPriceIndicator}>
          {renderDetails()}
        </div>
      )}
    </div>
  );
};

export default memo(PublicationInformation);
